import React, { PropsWithChildren } from 'react'

import { Title1 } from '@ui/Typography/Typography'
import { TextColorType } from '@ui/design-system/colors/colors'

interface Props extends PropsWithChildren {
  color?: TextColorType
}

export const ModalBodyTitle: React.FC<Props> = ({ children, color = 'text-med-em' }) => (
  <Title1 medium color={color}>
    {children}
  </Title1>
)
